import React from "react";
import type { DiagramLabels, DiagramStepConfig } from "@/lib/drawio/config";

interface DiagramStepperProps {
  steps: DiagramStepConfig[];
  /** -1 when no step is active. */
  current: number;
  labels: DiagramLabels;
  onChange: (index: number) => void;
}

/** Previous/next through the reading path; sits first in the toolbar line above the drawing. */
export default function DiagramStepper({ steps, current, labels, onChange }: DiagramStepperProps) {
  const count = steps.length;
  const position = current < 0 ? 0 : current + 1;
  const counter =
    current < 0 ? labels.stepsIdle.replace("{n}", String(count)) : labels.stepOf.replace("{i}", String(position)).replace("{n}", String(count));
  return (
    <div className="dg-stepper" role="group" aria-label={labels.steps}>
      <span className="dg-toolbar-label">{labels.steps}</span>
      <button type="button" className="dg-step-btn" disabled={current <= 0} onClick={() => onChange(Math.max(0, current - 1))}>
        {labels.prev}
      </button>
      <button type="button" className="dg-step-btn" disabled={current >= count - 1} onClick={() => onChange(Math.min(count - 1, current + 1))}>
        {labels.next}
      </button>
      <span className="dg-step-count">{counter}</span>
    </div>
  );
}
